export const DeviceLimitType = {
    CLIENT: "Customer",
    SYSTEM: "System"
};
